import React from 'react'
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter, numberFilter, Comparator } from 'react-bootstrap-table2-filter';
import ToolkitProvider, { CSVExport } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min';
import paginationFactory, { PaginationProvider, PaginationTotalStandalone, PaginationListStandalone } from 'react-bootstrap-table2-paginator';
// import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css'; 

const MyExportCSV = (props) => {
  const handleClick = () => {
    props.onExport();
  };
  return (
    <div className="col-md-4 center">
      <button className="btn btn-success" onClick={ handleClick }>Export Visible Data To File</button>
    </div>
  );
};

const columns = [{
  dataField: 'ordinal',
  text: '#',
  sort: true
},{
  dataField: 'billNumber',
  text: 'Bill Number',
  sort: true,
  filter: textFilter()
},{
  dataField: 'uid',
  text: 'Uid',
  filter: textFilter()
}, {
  dataField: 'usersPerBill',
  text: '# Users Per Bill',
  sort: true,
  filter: numberFilter({
    defaultValue: { number: 1, comparator: Comparator.GT }
  })
}];

var data = [];

export const Visits = ({visits, company}) => {
    data = [];
    const rowEvents = {
      onClick: (e, row, rowIndex) => {
        // alert("Row index: " + (rowIndex + 1));
      }
    };

    const rowStyle = (scan) => {};

    visits.map((visit,index) => {
        data.push({
          ordinal: index + 1,
          uid: visit.uid,
          billNumber: visit.billNumber,
          usersPerBill: visit.usersPerBill
        });
    });

    const options = {
      sizePerPageList: [{ text: '50', value: 50 }, { text: '100', value: 100 }, { text: '250', value: 250 }, {text: 'All', value: data.length}],
      showTotal: true
    }
    
    return (
        <ToolkitProvider
          keyField='billNumber' 
          data={ data } 
          columns={ columns }
          pagination={ paginationFactory(options) }
          exportCSV={ {
              exportAll: false,
              onlyExportFiltered: true
          } }>
          { props => (
            <div>
              <hr/>
                <MyExportCSV { ...props.csvProps }/>
              <hr />
              <BootstrapTable striped bordered hover { ...props.baseProps } 
                pagination={ paginationFactory(options) }
                rowStyle={ rowStyle } 
                rowEvents={ rowEvents } 
                bootstrap4={ true }
                tabIndexCell
                filter={ filterFactory() }
              />
            </div>
          )
          }
          </ToolkitProvider>
    )
}